import { AlertTriangle } from 'lucide-react';

/**
 * Fallback UI shown by Sentry.ErrorBoundary when an uncaught render error
 * crashes the app, instead of leaving the user on a blank page.
 */
export default function ErrorFallback() {
  return (
    <div className="bg-surface flex min-h-screen items-center justify-center px-4">
      <div className="max-w-md text-center">
        <div className="bg-brand-600 mx-auto flex h-12 w-12 items-center justify-center rounded-md text-white">
          <AlertTriangle className="h-6 w-6" aria-hidden="true" />
        </div>
        <h1 className="text-fg mt-6 text-2xl font-extrabold tracking-tight">
          Something went wrong
        </h1>
        <p className="text-fg-muted mt-2 text-base">
          An unexpected error occurred and the page could not be displayed. Try reloading — if the
          problem persists, please come back in a little while.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="bg-brand-600 hover:bg-brand-700 mt-6 inline-flex items-center rounded-md px-4 py-2 text-sm font-medium text-white"
        >
          Reload page
        </button>
      </div>
    </div>
  );
}
